import React from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import BreadCrumComponent from "../componentes/BreadCrumComponent";
import { verificarRol, gestionLegajos } from "../../constans/constants";
import MensajeFlash from "../mensajeFlash/MensajeFlash";
import PantallaCarga from "../mensajeFlash/PantallaCarga";
import BusquedaLegajo from "../componentes/BusquedaLegajo";
import { asignarVacaciones } from "./VacacionesService";

class AsignarVacaciones extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      legajoSeleccionado: null,
      dias: "",
      observaciones: "",
      guardando: false,
      mostrarMensajeFlash: false,
      mensajeFlash: "",
      mensajeFlashSeverity: "neutral",
    };
  }

  handleInput = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  handleLegajoChange = (legajo) => {
    this.setState({ legajoSeleccionado: legajo });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const { legajoSeleccionado, dias, observaciones } = this.state;

    if (!legajoSeleccionado) {
      this.flash("Debe seleccionar un colaborador", "error");
      return;
    }
    if (!dias || parseInt(dias) <= 0) {
      this.flash("La cantidad de días debe ser mayor a 0", "error");
      return;
    }

    this.setState({ guardando: true });
    try {
      const payload = {
        dias: parseInt(dias),
        observaciones: observaciones.trim() || null,
      };
      const res = await asignarVacaciones(legajoSeleccionado.legajoId, payload);
      const destino = legajoSeleccionado.legajoId
        ? `/administracion/vacaciones/legajo/${legajoSeleccionado.legajoId}`
        : "/administracion/vacaciones";
      this.props.history.push({
        pathname: destino,
        state: {
          legajoId: legajoSeleccionado.legajoId,
          nombreColaborador: legajoSeleccionado.nombreApellido,
          mostrarMensajeFlash: true,
          mensajeFlash: res.data?.mensaje || "Vacaciones asignadas correctamente",
          mensajeFlashSeverity: res.data?.error ? "error" : "exito",
        },
      });
    } catch (err) {
      this.setState({ guardando: false });
      this.flash(err?.response?.data?.mensaje || "No se pudo asignar las vacaciones", "error");
    }
  };

  flash = (mensaje, severity) =>
    this.setState({ mostrarMensajeFlash: true, mensajeFlash: mensaje, mensajeFlashSeverity: severity });

  render() {
    const {
      legajoSeleccionado,
      dias,
      observaciones,
      guardando,
      mostrarMensajeFlash,
      mensajeFlash,
      mensajeFlashSeverity,
    } = this.state;

    return (
      <div>
        <div className="template-base">
          <header className="component-header">
            <div className="page-container">
              <BreadCrumComponent
                backUrl="/administracion/vacaciones"
                breadcrumbs={[
                  { label: "Vacaciones", path: "/administracion/vacaciones" },
                  { label: "Asignar vacaciones" },
                ]}
              />

              <nav className="nav-area">
                <NavLink to="/administracion/usuarios" className="nav-link">
                  <span className="material-symbols-outlined">account_circle</span>
                  Usuarios
                </NavLink>
                <NavLink to="/administracion/grupos" className="nav-link">
                  <span className="material-symbols-outlined">supervised_user_circle</span>
                  Grupos de usuarios
                </NavLink>
                {verificarRol(JSON.parse(localStorage.getItem("roles")), [gestionLegajos]) && <NavLink to="/administracion/legajos" className="nav-link">
                  <span className="material-symbols-outlined">assignment_ind</span>
                  Legajos
                </NavLink>}
                {verificarRol(JSON.parse(localStorage.getItem("roles")), [gestionLegajos]) && <NavLink to="/administracion/vacaciones" className="nav-link">
                  <span className="material-symbols-outlined">beach_access</span>
                  Vacaciones
                </NavLink>}
              </nav>

              <div className="head-area">
                <div className="caption-area">
                  <h1 className="page-title">Asignar vacaciones</h1>
                  <p className="page-description">
                    Complete el siguiente formulario para asignar días de vacaciones a un colaborador
                  </p>
                </div>
                <div className="head-actions">
                  <button
                    className="btn-medium btn-base-outline"
                    type="button"
                    onClick={() => this.props.history.push("/administracion/vacaciones")}
                  >
                    Cancelar
                  </button>
                  <button
                    className="btn-medium btn-primary"
                    onClick={this.handleSubmit}
                    disabled={guardando}
                  >
                    {guardando ? "Guardando..." : "Guardar cambios"}
                  </button>
                </div>
              </div>
            </div>
          </header>

          <div className="wrapperContent">
            <div className="page-container card">
              <form className="form container-sm" onSubmit={this.handleSubmit}>

                <h3 className="form-subtitle">Colaborador</h3>

                <BusquedaLegajo onLegajoChange={this.handleLegajoChange} />

                {legajoSeleccionado && (
                  <div className="component-card-info">
                    <div className="card__cols">
                      <div className="content-inner">
                        <span className="label">Nombre completo</span>
                        <span className="txt">{legajoSeleccionado.nombreApellido}</span>
                      </div>
                      <div className="content-inner">
                        <span className="label">Cédula de identidad</span>
                        <span className="txt">{legajoSeleccionado.cedula}</span>
                      </div>
                      <div className="content-inner">
                        <span className="label">Usuario</span>
                        <span className="txt">{legajoSeleccionado.username}</span>
                      </div>
                    </div>
                  </div>
                )}

                <h3 className="form-subtitle">Datos de vacaciones</h3>

                <div className="form-group__inline">
                  <div className="form-group">
                    <input
                      type="number"
                      id="dias"
                      name="dias"
                      className="form-input"
                      placeholder=" "
                      min="1"
                      value={dias}
                      onChange={this.handleInput}
                    />
                    <label htmlFor="dias" className="form-label">Días a asignar *</label>
                  </div>
                </div>

                <div className="form-group">
                  <textarea
                    id="observaciones"
                    name="observaciones"
                    className="form-textarea"
                    placeholder=" "
                    rows={4}
                    value={observaciones}
                    onChange={this.handleInput}
                  />
                  <label htmlFor="observaciones" className="form-label-textarea">Observaciones</label>
                </div>

              </form>
            </div>
          </div>
        </div>

        <MensajeFlash
          visible={mostrarMensajeFlash}
          mensaje={mensajeFlash}
          severity={mensajeFlashSeverity}
        />
        <PantallaCarga open={guardando} />
      </div>
    );
  }
}

export default connect(null, null)(AsignarVacaciones);
